<template>
  <BlockUI :blocked="proc">
    <ol class="breadcrumb">
      <router-link to="/" class="breadcrumb-item"> Dashboard </router-link>
      <router-link to="/settledGames" class="breadcrumb-item">
        <span>Settled Matches</span>
      </router-link>
      <router-link to="/profitandloss" class="breadcrumb-item">
        <span> Profit & Loss </span>
      </router-link>
      <a href="javascript:void(0);" class="breadcrumb-item textdecorationnone">
        <span class="colorbase">{{ id1 }}</span>
      </a>
      <router-link to="/statement" class="breadcrumb-item">
        <span>My Stmt.</span>
      </router-link>
      <router-link to="/ledgers" class="breadcrumb-item">
        <span>Company Ledgers</span>
      </router-link>
      <router-link to="/collectionReport" class="breadcrumb-item">
        <span>Collection Report</span>
      </router-link>
      <router-link to="/liveGames" class="breadcrumb-item">
        <span>Live Matches</span>
      </router-link>
    </ol>
    <div class="row">
      <div class="col-xs-12">
        <router-link :to="'/betslips/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm padding-0 marginright5" :class="{ 'btn-success': getrname === 'BetSlips', 'btn-indigo': getrname !== 'BetSlips' }">Bet Slips</router-link>
        <router-link :to="'/betslips2/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm padding-0 marginright5" :class="{ 'btn-success': getrname === 'BetSlips2', 'btn-indigo': getrname !== 'BetSlips2' }">Bet Slips2</router-link>
        <router-link :to="'/sessionbetslips/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm padding-0 marginright5" v-if="sp === 'Cricket'" :class="{ 'btn-success': getrname === 'SessionBetSlips', 'btn-indigo': getrname !== 'SessionBetSlips' }">Session Bet Slips</router-link>
        <button type="button" class="btn btn-sm padding-0 btn-indigo marginright5">Live Report</button>
        <router-link :to="'/clientreport/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm padding-0 btn-indigo marginright5">Client Report</router-link>
        <router-link :to="'/collectionreport1/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm padding-0 btn-indigo marginright5">Collection Report</router-link>
        <router-link :to="'/companyreport/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm padding-0 btn-indigo marginright5">Company Report</router-link>
        <router-link :to="'/sessionearningsreport/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm padding-0 btn-indigo" v-if="sp === 'Cricket'">Session Earning Report</router-link>
      </div>
    </div>
    <div class="row" v-if="getrname === 'BetSlips' || getrname === 'SessionBetSlips'">
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">Total Bets</span>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-12">
                <h3 class="mb-0">{{ cbetstotal.totalbets }}</h3>
              </div>
            </div>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">Settled Bets</span>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-12">
                <h3 class="mb-0">{{ cbetstotal.settledbets }}</h3>
              </div>
            </div>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">UnSettled Bets</span>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-12">
                <h3 class="mb-0">{{ cbetstotal.unsettledbets }}</h3>
              </div>
            </div>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">Reverted Bets</span>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-12">
                <h3 class="mb-0">{{ cbetstotal.revertedbets }}</h3>
              </div>
            </div>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="getrname === 'BetSlips2'">
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">Total Bets</span>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-12">
                <h3 class="mb-0">{{ cbetstotal1.totalbets }}</h3>
              </div>
            </div>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">Settled Bets</span>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-12">
                <h3 class="mb-0">{{ cbetstotal1.settledbets }}</h3>
              </div>
            </div>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">UnSettled Bets</span>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-12">
                <h3 class="mb-0">{{ cbetstotal1.unsettledbets }}</h3>
              </div>
            </div>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">Reverted Bets</span>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-12">
                <h3 class="mb-0">{{ cbetstotal1.revertedbets }}</h3>
              </div>
            </div>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6" v-if="getrname === 'BetSlips' || getrname === 'SessionBetSlips'">
        <select class="form-select" v-model="selmarkettypes">
          <option v-for="m in markettypes" :key="m" :value="m" :selected="m === selmarkettypes">{{ m }}</option>
        </select>
      </div>
      <div class="col-6" :class="{ 'col-6': getrname === 'BetSlips' || getrname === 'SessionBetSlips', 'col-12': getrname === 'BetSlips2' }">
        <select class="form-select" v-model="seluser">
          <option v-for="m in markettypesusers[selmarkettypes]" :key="m" :value="m" :selected="m === seluser">{{ m }}</option>
        </select>
      </div>
    </div>
    <div class="table-responsive" v-if="getrname === 'BetSlips2'">
      <ul class="pagination mb-0">
        <li v-for="n in markettypes" :key="n" class="page-item" v-on:click="selmarkettypes = n" style="white-space: nowrap">
          <a href="javascript:void(0);" class="page-link" :class="{ active: n === selmarkettypes }">{{ n }}</a>
        </li>
      </ul>
    </div>
    <div class="row" v-if="getrname === 'BetSlips2'">
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">Total Bets</span>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-12">
                <h3 class="mb-0">{{ cbetstotal.totalbets }}</h3>
              </div>
            </div>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">Settled Bets</span>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-12">
                <h3 class="mb-0">{{ cbetstotal.settledbets }}</h3>
              </div>
            </div>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">UnSettled Bets</span>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-12">
                <h3 class="mb-0">{{ cbetstotal.unsettledbets }}</h3>
              </div>
            </div>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">Reverted Bets</span>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-12">
                <h3 class="mb-0">{{ cbetstotal.revertedbets }}</h3>
              </div>
            </div>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th>Runner</th>
            <th>Position</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in runners[selmarkettypes]" :key="r" :class="{ 'text-success': getwinner() === r, 'text-danger': getwinner() !== r }">
            <td>
              {{ r }}
            </td>
            <td class="text-end" v-if="getbook(r) !== undefined">
              {{ getbook(r).toLocaleString() }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-sm table-hover">
        <thead>
          <tr v-if="getrname === 'BetSlips' || getrname === 'BetSlips2'">
            <th colspan="8" class="text-center" v-if="sp === 'Cricket' || (sp === 'Soccer' && selmarkettypes !== 'Match Odds')">Bets of &nbsp;{{ selmarkettypes }}</th>
            <th colspan="9" class="text-center" v-if="sp === 'Soccer' && selmarkettypes === 'Match Odds'">Bets of &nbsp;{{ selmarkettypes }}</th>
            <th colspan="4" class="text-center">My Share / Position</th>
            <th colspan="2" class="text-center">Settlement</th>
          </tr>
          <tr v-if="getrname === 'SessionBetSlips'">
            <th colspan="10" class="text-center">Bets of &nbsp;{{ selmarkettypes }}</th>
            <th colspan="3" class="text-center">My Share / Position</th>
            <th colspan="4" class="text-center">Settlement</th>
            <th colspan="2" class="text-center">Bet Info</th>
          </tr>
          <tr v-if="getrname === 'BetSlips' || getrname === 'BetSlips2'">
            <th>DATE (IST)</th>
            <!-- <th>Market Title</th> -->
            <th class="text-end">RATE</th>
            <th class="text-end">AMOUNT</th>
            <th>MODE</th>
            <th>Runner Name</th>
            <th>User</th>
            <th v-for="r in runners[selmarkettypes]" :key="r" class="text-end fontsizesmall">{{ r }}</th>
            <th class="text-end fontsizesmall">MY Share</th>
            <th v-for="r in runners[selmarkettypes]" :key="r" class="text-end fontsizesmall">{{ r }}</th>
            <th>Status</th>
            <th class="text-end">Plus / Minus</th>
            <th>Upline</th>
            <th>Ip</th>
            <th>Device</th>
          </tr>
          <tr v-if="getrname === 'SessionBetSlips'">
            <th>Bet ID</th>
            <th>DATE (IST)</th>
            <th>User</th>
            <th>Session Title</th>
            <th class="text-end">RATE</th>
            <th class="text-end">RUNS</th>
            <th class="text-end">AMOUNT</th>
            <th>MODE</th>
            <th class="text-end">No</th>
            <th class="text-end">Yes</th>
            <th class="text-end fontsizesmall">MY Share</th>
            <th class="text-end">No</th>
            <th class="text-end">Yes</th>
            <th>Status</th>
            <th class="text-end">Plus / Minus</th>
            <th class="text-end fontsizesmall">Result</th>
            <th>Upline</th>
            <th>Ip</th>
            <th>Device</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="b in cbets" :key="b.Id" v-if="getrname === 'BetSlips' || getrname === 'BetSlips2'">
            <!-- <td colspan="18"><pre>{{ b }}</pre></td> -->
            <td>{{ b.D.replace("IST", "") }}</td>
            <!-- <td>{{ b.M }}</td> -->
            <td class="text-end">
              <span v-if="b.P > 0">{{
                (b.P - 1.0).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}</span>
            </td>
            <td class="text-end">
              <span v-if="b.A > 0">{{ b.A.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-center">
              <button class="btn btn-grd btn-sm padding-0 text-white fontsizesmall" :class="{ 'btn-grd-primary': b.T === 'LAGAI', 'btn-grd-danger': b.T === 'KHAI' }">{{ b.T }}</button>
            </td>
            <td>{{ b.S }}</td>
            <td>{{ b.N }}</td>
            <td v-for="r in runners[selmarkettypes]" :key="r" class="text-end">
              <span v-if="b.runners[r] !== 0">
                {{
                  b.runners[r].toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td class="text-end">
              <span v-if="b.my > 0">{{ b.my.toLocaleString("en-IN") }} %</span>
            </td>
            <td v-for="r in runners[selmarkettypes]" :key="r" class="text-end">
              <span v-if="b.runners1[r] !== undefined && b.runners1[r] !== 0">
                {{
                  b.runners1[r].toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td class="text-center">
              <button class="btn btn-sm padding-0 fontsizesmall" :class="{ 'btn-outline-info': b.B === 'Settled', 'btn-outline-danger': b.B === 'Deleted', 'btn-outline-primary': b.B === 'Matched', 'btn-dark': b.B === 'UnMatched' }">{{ b.B }}</button>
            </td>
            <td class="text-end">
              <span v-if="b.myp !== undefined && b.myp !== 0">
                {{
                  b.myp.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td>{{ b.H }}</td>
            <td>
              <a href="javascript:void(0);" v-on:click="showipd(b.Ip)">
                <b>{{ b.Ip }}</b>
              </a>
            </td>
            <td>
              <a href="javascript:void(0);" v-on:click="showdeviced(b.Dev)">
                <b>{{ b.Dev }}</b>
              </a>
            </td>
          </tr>
          <tr v-for="b in cbets" :key="b.Id" v-if="getrname === 'SessionBetSlips'">
            <td>{{ b.Id }}</td>
            <td>{{ b.D.replace("IST", "") }}</td>
            <td>{{ b.N }}</td>
            <td>{{ b.S }}</td>
            <td class="text-end">
              <span v-if="b.P !== undefined && b.P > 0">{{ b.P.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              {{ b.S1 }}
            </td>
            <td class="text-end">
              <span v-if="b.A !== undefined && b.A > 0">{{ b.A.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-center">
              <button class="btn btn-sm padding-0 text-white fontsizesmall" :class="{ 'btn-primary': b.T === 'YES', 'btn-danger': b.T === 'NOT' }">{{ b.T }}</button>
            </td>
            <td class="text-end">
              <span v-if="b.NO !== undefined && b.NO !== 0">{{ b.NO.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="b.YES !== undefined && b.YES !== 0">{{ b.YES.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="b.my !== undefined && b.my > 0">{{ b.my.toLocaleString("en-IN") }} %</span>
            </td>
            <td class="text-end">
              <span v-if="b.NO1 !== undefined && b.NO1 !== 0">{{ b.NO1.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="b.YES1 !== undefined && b.YES1 !== 0">{{ b.YES1.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-center">
              <button class="btn btn-sm padding-0 fontsizesmall" :class="{ 'btn-outline-theme': b.B === 'Settled', 'btn-danger': b.B === 'Deleted', 'btn-primary': b.B === 'Matched', 'btn-dark': b.B === 'UnMatched' }">{{ b.B }}</button>
            </td>
            <td class="text-end">
              <span v-if="b.myp !== undefined && b.myp !== 0">{{ b.myp.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">{{ fancyresult[b.S] }}</td>
            <td>{{ b.H }}</td>
            <td>
              <a href="javascript:void(0);" v-on:click="showipd(b.Ip)">
                <b>{{ b.Ip }}</b>
              </a>
            </td>
            <td>
              <a href="javascript:void(0);" v-on:click="showdeviced(b.Dev)">
                <b>{{ b.Dev }}</b>
              </a>
            </td>
          </tr>
          <tr v-if="getrname === 'BetSlips' || getrname === 'BetSlips2'">
            <td></td>
            <td>Total</td>
            <td class="text-end">
              <span v-if="cbetstotal.Amt > 0">
                {{
                  cbetstotal.Amt.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td v-for="r in runners[selmarkettypes]" :key="r" class="text-end">
              <span v-if="cbetstotal.runnerst[r] !== 0"
                >{{
                  cbetstotal.runnerst[r].toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.avgp > 0">{{
                cbetstotal.avgp.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}</span>
            </td>
            <td v-for="r in runners[selmarkettypes]" :key="r" class="text-end">
              <span v-if="cbetstotal.runners1t[r] !== 0"
                >{{
                  cbetstotal.runners1t[r].toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td></td>
            <td class="text-end">
              <span v-if="cbetstotal.mypt > 0 || cbetstotal.mypt < 0">
                {{
                  cbetstotal.mypt.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td></td>
          </tr>
          <tr v-if="getrname === 'SessionBetSlips'">
            <td></td>
            <td></td>
            <td>Total</td>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-end">
              <span v-if="cbetstotal.Amt !== undefined && cbetstotal.Amt > 0">
                {{
                  cbetstotal.Amt.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td></td>
            <td class="text-end">
              <span v-if="cbetstotal.Nototal !== undefined && cbetstotal.Nototal !== 0">
                {{
                  cbetstotal.Nototal.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.Yestotal !== undefined && cbetstotal.Yestotal !== 0">
                {{
                  cbetstotal.Yestotal.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td></td>
            <td class="text-end">
              <span v-if="cbetstotal.Nototal1 !== undefined && cbetstotal.Nototal1 !== 0">
                {{
                  cbetstotal.Nototal1.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.Yestotal1 !== undefined && cbetstotal.Yestotal1 !== 0">
                {{
                  cbetstotal.Yestotal1.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td></td>
            <td class="text-end">
              <span v-if="cbetstotal.mypt !== undefined && cbetstotal.mypt !== 0">
                {{
                  cbetstotal.mypt.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </BlockUI>
  <Dialog v-model:visible="showip" :dialog="true" :maximizable="maximum" style="width: 95%; height: 95%">
    <iframe style="width: 95vw; height: 95vh" :src="'https://www.magurano.eu/whats-my-ip-free?ip=' + ip"></iframe>
  </Dialog>
  <Dialog v-model:visible="showdevice" :dialog="true" :maximizable="maximum" style="width: 95%; height: 95%">
    <iframe style="width: 95vw; height: 95vh" :src="'https://www.magurano.eu/device?id=' + did"></iframe>
  </Dialog>
</template>

<script>
import $$vm from "@/data/index";
import BlockUI from "primevue/blockui";
import Dialog from "primevue/dialog";

export default {
  name: "BetSlips",
  components: {
    BlockUI,
    Dialog,
  },
  data() {
    return {
      id: "",
      id1: "",
      sp: "",
      proc: false,
      runners: {},
      bets: [],
      downline: [],
      markettypes: [],
      selmarkettypes: "",
      markettypesusers: {},
      settled: [],
      seluser: "All Users",
      cbets: [],
      cbetstotal: {},
      cbetstotal1: {},
      books: [],
      routename: "",
      fancyresult: {},
      showip: false,
      showdevice: false,
      maximum: true,
      calldata: false,
      fullpath: "",
    };
  },
  mounted() {
    this.update();
    this.calldata = false;
  },
  watch: {
    selmarkettypes(val, o) {
      if (val != null && val !== undefined) {
        this.seluser = "All Users";
        if (this.routename === "SessionBetSlips") {
          this.sbetsupdate();
        } else {
          this.cbetsupdate();
        }
      }
    },
    seluser(val, o) {
      if (val != null && val !== undefined) {
        if (this.routename === "SessionBetSlips") {
          this.sbetsupdate();
        } else {
          this.cbetsupdate();
        }
      }
    },
  },
  computed: {
    getrname: function () {
      return this.$route.name;
    },
  },
  methods: {
    cbetsupdate: function () {
      var self = this;
      self.proc = true;
      self.cbets = [];
      self.cbetstotal = { Amt: 0, runnerst: {}, runners1t: {}, plusminust: {}, avgp: 0, totalbets: 0, settledbets: 0, unsettledbets: 0, revertedbets: 0, mypt: 0 };
      self.cbetstotal1 = { totalbets: 0, settledbets: 0, unsettledbets: 0, revertedbets: 0 };
      var selmarkettypes = self.selmarkettypes;
      // if (self.selmarkettypes === "Bookmaker" || self.selmarkettypes === "Bookmaker1" || self.selmarkettypes === "Bookmaker2"){
      //   selmarkettypes = "Match Odds";
      // }
      $.each(self.runners[selmarkettypes], function (oo, pp) {
        self.cbetstotal.runnerst[pp] = 0;
        self.cbetstotal.runners1t[pp] = 0;
      });
      // console.log(self.bets);
      $.each(self.bets, function (ii, jj) {
        if (jj["B"] === "Cancelled") {
          return;
        }
        if (jj["B"] === "Settled") {
          self.cbetstotal1.settledbets += 1;
        } else if (jj["B"] === "Matched") {
          self.cbetstotal1.unsettledbets += 1;
        } else if (jj["B"] === "Deleted") {
          self.cbetstotal1.revertedbets += 1;
        }
        self.cbetstotal1.totalbets += 1;
        var markettype = jj["M"];
        var wn = "";
        if (markettype === "Bookmaker" || markettype === "Bookmaker1") {
          $.each(self.settled, function (oo8, pp8) {
            if (pp8["M"] === "Match Odds") {
              wn = pp8["W"];
            }
          });
        } else {
          $.each(self.settled, function (oo8, pp8) {
            if (pp8["M"] === markettype) {
              wn = pp8["W"];
              // console.log(wn);
            }
          });
        }
        if (markettype === self.selmarkettypes) {
          var name = jj["N"];
          if (self.seluser !== "All Users" && name !== self.seluser) {
            return;
          }
          self.cbetstotal.totalbets += 1;
          if (jj["B"] === "Settled") {
            self.cbetstotal.settledbets += 1;
          } else if (jj["B"] === "Matched") {
            self.cbetstotal.unsettledbets += 1;
          } else if (jj["B"] === "Deleted") {
            self.cbetstotal.revertedbets += 1;
          }
          var pr = 0.0;
          var li = 0.0;
          var runner = jj["S"];
          var amt = jj["A"];
          var price = jj["P"] - 1.0;
          if (price > 0.0) {
            self.cbetstotal.Amt += amt;
          }
          if (jj["T"] === "LAGAI") {
            pr = price * amt;
            li = -1 * amt;
          } else if (jj["T"] === "KHAI") {
            li = amt;
            pr = -1 * price * amt;
          }
          jj["runners"] = {};
          jj["runners1"] = {};
          $.each(self.runners[selmarkettypes], function (oo, pp) {
            if (pp === runner) {
              jj["runners"][pp] = pr;
              self.cbetstotal.runnerst[pp] += jj["runners"][pp];
            } else {
              jj["runners"][pp] = li;
              self.cbetstotal.runnerst[pp] += jj["runners"][pp];
            }
          });
          var user = jj["H"].split(" ").pop();
          if (user.length === 0) {
            jj["my"] = 100;
            var found = false;
            $.each(self.runners[selmarkettypes], function (oo, pp) {
              if (pp === runner) {
                jj["runners1"][pp] = (-1 * pr * jj["my"]) / 100;
                self.cbetstotal.runners1t[pp] += jj["runners1"][pp];
              } else {
                jj["runners1"][pp] = (-1 * li * jj["my"]) / 100;
                self.cbetstotal.runners1t[pp] += jj["runners1"][pp];
              }
              if (pp === wn) {
                found = true;
                jj["myp"] = jj["runners1"][pp];
                self.cbetstotal.mypt += jj["myp"];
              }
            });
            if (!found) {
              jj["myp"] = 0;
            }
          } else {
            $.each(self.downline, function (oo2, pp2) {
              if (pp2["N"] === user) {
                if (self.sp === "Cricket") {
                    jj["my"] = pp2["S2"];
                } else {
                  jj["my"] = pp2["S"];
                }
                var found = false;
                $.each(self.runners[selmarkettypes], function (oo, pp) {
                  if (pp === runner) {
                    jj["runners1"][pp] = (-1 * pr * jj["my"]) / 100;
                    self.cbetstotal.runners1t[pp] += jj["runners1"][pp];
                  } else {
                    jj["runners1"][pp] = (-1 * li * jj["my"]) / 100;
                    self.cbetstotal.runners1t[pp] += jj["runners1"][pp];
                  }
                  if (pp === wn) {
                    found = true;
                    jj["myp"] = jj["runners1"][pp];
                    self.cbetstotal.mypt += jj["myp"];
                  }
                });
                if (!found) {
                  jj["myp"] = 0;
                }
              }
            });
          }
          self.cbets.push(jj);
        }
      });
      self.proc = false;
    },
    sbetsupdate: function () {
      var self = this;
      self.proc = true;
      self.cbets = [];
      self.cbetstotal = { Amt: 0, Nototal: 0, Yestotal: 0, Nototal1: 0, Yestotal1: 0, plusminust: 0, avgp: 0, totalbets: 0, settledbets: 0, unsettledbets: 0, revertedbets: 0, mypt: 0 };
      self.cbetstotal1 = { totalbets: 0, settledbets: 0, unsettledbets: 0, revertedbets: 0 };
      $.each(this.bets, function (ii, jj) {
        var fancy = jj["S"];
        var user = jj["N"];
        if (self.selmarkettypes !== "All Fancies" && self.selmarkettypes !== fancy) {
          return;
        } else if (self.selmarkettypes === "All Fancies" && self.seluser !== "All Users") {
          if (user !== self.seluser) {
            return;
          }
        } else if (self.selmarkettypes !== "All Fancies" && self.seluser !== "All Users") {
          if (user !== self.seluser) {
            return;
          }
        }
        if (jj["P"] > 0.0) {
          self.cbetstotal.Amt += jj["A"];
        }
        self.cbetstotal.totalbets += 1;
        if (jj["B"] === "Settled") {
          self.cbetstotal.settledbets += 1;
        } else if (jj["B"] === "Matched") {
          self.cbetstotal.unsettledbets += 1;
        } else if (jj["B"] === "Deleted") {
          self.cbetstotal.revertedbets += 1;
        }
        var user = jj["H"].split(" ").pop();
        jj["myp"] = 0.0;
        if (user.length === 0) {
          jj["my"] = 100;
          jj["NO1"] = (jj["NO"] * jj["my"]) / 100;
          jj["YES1"] = (jj["YES"] * jj["my"]) / 100;
          var result = self.fancyresult[jj["S"]];
          if (result) {
            var result1 = parseInt(self.fancyresult[jj["S"]]);
            if (jj["T"] === "YES") {
              if (result1 < jj["S1"]) {
                jj["myp"] = jj["YES1"];
              } else {
                jj["myp"] = jj["NO1"];
              }
            } else {
              if (result1 >= jj["S1"]) {
                jj["myp"] = jj["YES1"];
              } else {
                jj["myp"] = jj["NO1"];
              }
            }
          }
          self.cbetstotal.Nototal += jj["NO"];
          self.cbetstotal.Yestotal += jj["YES"];
          self.cbetstotal.Nototal1 += jj["NO1"];
          self.cbetstotal.Yestotal1 += jj["YES1"];
          self.cbetstotal.mypt += jj["myp"];
        } else {
          $.each(self.downline, function (oo2, pp2) {
            var users = jj["H"].split(' ');
            $.each(users, function(userso, user){
              if (pp2["N"] === user) {
              jj["my"] = pp2["S1"];
              jj["NO1"] = (-1 * jj["NO"] * jj["my"]) / 100;
              jj["YES1"] = (-1 * jj["YES"] * jj["my"]) / 100;
              var result = self.fancyresult[jj["S"]];
              if (result) {
                var result1 = parseInt(self.fancyresult[jj["S"]]);
                if (jj["T"] === "YES") {
                  if (result1 < jj["S1"]) {
                    jj["myp"] = jj["NO1"];
                  } else {
                    jj["myp"] = jj["YES1"];
                  }
                } else {
                  if (result1 >= jj["S1"]) {
                    jj["myp"] = jj["YES1"];
                  } else {
                    jj["myp"] = jj["NO1"];
                  }
                }
              }
              self.cbetstotal.Nototal += jj["NO"];
              self.cbetstotal.Yestotal += jj["YES"];
              self.cbetstotal.Nototal1 += jj["NO1"];
              self.cbetstotal.Yestotal1 += jj["YES1"];
              self.cbetstotal.mypt += jj["myp"];
            }
            });
          });
        }
        self.cbets.push(jj);
      });
      self.proc = false;
    },
    update: function () {
      var self = this;
      if ($$vm.cn) {
        if (self.$route.params.id !== undefined && self.$route.params.id !== self.id) {
          self.id = self.$route.params.id;
          self.calldata = true;
        }
        if (self.$route.params.id1 !== undefined && self.$route.params.id1 !== self.id1) {
          self.id1 = self.$route.params.id1;
          self.calldata = true;
        }
        if (self.$route.params.sp !== undefined && self.$route.params.sp !== self.sp) {
          self.sp = self.$route.params.sp;
          self.calldata = true;
        }
        if (self.$route.name !== undefined && self.$route.name !== self.routename) {
          self.routename = self.$route.name;
          self.calldata = true;
        }
        if (self.$route.name !== undefined && self.$route.fullpath !== self.fullpath) {
          self.fullpath = self.$route.fullpath;
          self.calldata = true;
        }
        if (self.calldata) {
          self.calldata = false;
          self.getd();
        }
      }
      setTimeout(function () {
        self.update();
      }, 1000);
    },
    getd: function () {
      var self = this;
      if ($$vm.cn) {
        self.proc = true;
        self.downline = {};
        self.settled = {};
        self.books = [];
        self.markettypes = [];
        self.selmarkettypes = "";
        self.markettypesusers = {};
        self.runners = {};
        self.bets = [];
        self.seluser = "All Users";
        if (self.routename === "BetSlips" || self.routename === "BetSlips2") {
          $$vm.c.invoke("betslips", self.id).then(
            function (data) {
              data = $$vm.decompress(data);
              self.downline = data.S;
              self.settled = data.Rt;
              self.books = data.D;
              $.each(data.D, function (ii, jj) {
                var found = false;
                var type = jj["M"];
                if ((type === "Match Odds" || type === "Win") && self.selmarkettypes === "") {
                  self.selmarkettypes = type;
                }
                $.each(self.markettypes, function (iia, jja) {
                  if (jja === type) {
                    found = true;
                  }
                });
                if (!found) {
                  self.markettypes.push(type);
                }
              });
              if (self.selmarkettypes.length === 0 && self.markettypes.length > 0) {
                self.selmarkettypes = self.markettypes[0];
              }
              $.each(data.R, function (ii, jj) {
                var ma = jj["T"];
                var name = jj["N"];
                var isr = self.runners[ma];
                if (isr === undefined) {
                  var val = [];
                  val.push(name);
                  self.runners[ma] = val;
                } else {
                  var val = self.runners[ma];
                  val.push(name);
                  self.runners[ma] = val;
                }
              });
              if (self.sp === "Cricket") {
                $.each(self.runners, function (oo4, pp4) {
                  if (oo4 === "Match Odds") {
                    self.runners["Bookmaker"] = pp4;
                    self.runners["Bookmaker1"] = pp4;
                  }
                });
              }
              else {
                // $.each(self.runners, function (oo4, pp4) {
                //   self.runners[oo4] = pp4;
                // });
              }
              $.each(data.B, function (db, dc) {
                var hers = dc["H"].split(" ");
                var foundindex = -1;
                $.each(hers, function (db1, dc1) {
                  if ($$vm.bala.U.toLowerCase() === dc1.toLowerCase()) {
                    foundindex = db1;
                    return;
                  }
                });
                if (foundindex !== -1) {
                  var hernew = "";
                  $.each(hers, function (db1, dc1) {
                    if (db1 < foundindex) {
                      hernew += dc1 + " ";
                    }
                  });
                  dc["H"] = hernew.trim();
                }
              });
              self.bets = _.sortBy(data.B, "Id").reverse();
              $.each(data.B, function (ii, jj) {
                var type = jj["M"];
                var istype = self.markettypesusers[type];
                if (istype === undefined) {
                  self.markettypesusers[type] = [];
                }
                var user = jj["N"];
                var found = false;
                $.each(self.markettypesusers[type], function (ii, jj) {
                  if (jj === user) {
                    found = true;
                  }
                });
                if (!found) {
                  var val = self.markettypesusers[type];
                  val.push(user);
                  self.markettypesusers[type] = val;
                }
              });
              $.each(self.markettypesusers, function (ii, jj) {
                jj = jj.sort();
                jj.unshift("All Users");
              });
              //self.cbetsupdate();
              self.proc = false;
            },
            function (err) {
              self.proc = false;
            }
          );
        } else if (self.routename === "SessionBetSlips") {
          $$vm.c.invoke("sessionbetslips", self.id).then(
            function (data) {
              data = $$vm.decompress(data);
              self.selmarkettypes = "All Fancies";
              self.downline = data.S;
              $.each(data.Rt, function (ii, jj) {
                var found = false;
                var type = jj["M"];
                $.each(self.markettypes, function (iia, jja) {
                  if (jja === type) {
                    found = true;
                  }
                });
                if (!found) {
                  self.markettypes.push(type);
                }
                var isresult = self.fancyresult[type];
                if (isresult === undefined) {
                  self.fancyresult[type] = jj["W"];
                }
              });
              self.markettypes.unshift("All Fancies");
              $.each(data.B, function (ii, jj) {
                var mode = jj["T"];
                if (mode === "YES") {
                  jj["NO"] = -1 * jj["A"];
                  jj["YES"] = jj["P"] * jj["A"];
                } else {
                  jj["NO"] = jj["A"];
                  jj["YES"] = -1 * jj["P"] * jj["A"];
                }
                var type = jj["S"];
                var istype = self.markettypesusers[type];
                if (istype === undefined) {
                  self.markettypesusers[type] = [];
                }
                var user = jj["N"];
                var found = false;
                $.each(self.markettypesusers[type], function (ii, jj) {
                  if (jj === user) {
                    found = true;
                  }
                });
                if (!found) {
                  var val = self.markettypesusers[type];
                  val.push(user);
                  self.markettypesusers[type] = val;
                }
                var type1 = "All Fancies";
                var istype1 = self.markettypesusers[type1];
                if (istype1 === undefined) {
                  self.markettypesusers[type1] = [];
                }
                $.each(self.markettypesusers[type1], function (ii, jj) {
                  if (jj === user) {
                    found = true;
                  }
                });
                if (!found) {
                  var val = self.markettypesusers[type1];
                  val.push(user);
                  self.markettypesusers[type1] = val;
                }
              });
              $.each(self.markettypesusers, function (ii, jj) {
                jj = jj.sort();
                jj.unshift("All Users");
              });
              // self.bets = data.B;
              self.bets = _.sortBy(data.B, "Id").reverse();
              self.proc = false;
            },
            function (er) {
              self.proc = false;
            }
          );
        }
      } else {
        setTimeout(function () {
          self.getd();
        }, 200);
      }
    },
    getbook: function (a1) {
      var self = this;
      var amt = 0.0;
      $.each(self.books, function (a, b) {
        if (b["M"] === self.selmarkettypes && b["S"] === a1) {
          amt = b["E"];
        }
      });
      return amt;
    },
    getwinner: function () {
      var self = this;
      var wn = "";
      $.each(self.settled, function (oo8, pp8) {
        if (self.selmarkettypes === "Bookmaker") {
          if (pp8["M"] === "Match Odds") {
            wn = pp8["W"];
          }
        } else if (pp8["M"] === self.selmarkettypes) {
          wn = pp8["W"];
        }
      });
      return wn;
    },
    showipd: function (ip) {
      var self = this;
      if (ip !== undefined && ip !== null && ip.length > 0) {
        self.ip = ip;
        self.showip = true;
      }
    },
    showdeviced: function (did) {
      var self = this;
      if (did !== undefined && did !== null && did > 0) {
        self.did = did;
        self.showdevice = true;
      }
    },
  },
};
</script>

<style></style>
